export const GIFT_PAYMENT_PAGE_STATIC_KEY = 'giftPaymentPage'

export default GIFT_PAYMENT_PAGE_STATIC_KEY
